export default __webpack_public_path__ + "static/media/KOD0014-min.d60a9821.webp";